import React from 'react';
import styled from 'App/styled';

interface PageProps {
  idx: number;
  selectedPage: number;
  changePage: (page: number) => void;
  number: number;
  totalPages: number;
}

// Replace with new token
const Pill = styled.a`
  width: 40px;
  height: 40px;
  display: flex;
  ${({ theme }) => theme.typography.bodyLarge};
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  line-height: 16px;
  color: #3f414d;
  text-decoration: none;
  border-radius: 50%;
  &.active {
    background-color: ${(props) => props.theme.brandPrimary};
    color: #fff;
    pointer-events: none;
  }
  &:hover {
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 10%);
    background-color: #fff;
    color: ${(props) => props.theme.brandPrimary};
    font-weight: 700;
    cursor: pointer;
  }
`;

const PaginationItem = styled.li`
  display: flex;
  align-items: center;
`;

const PageNumber = ({
  number,
  changePage,
  selectedPage,
  idx,
  totalPages,
}: PageProps) => {
  if (totalPages < number) {
    return null;
  }
  const isSelected = Number(selectedPage) === number;
  const activeClass = isSelected ? 'active' : '';
  const handlePage = () => {
    changePage(number);
  };
  return (
    <PaginationItem>
      <Pill
        key={idx}
        className={activeClass}
        onClick={handlePage}
        aria-label={`Page ${number}`}
        {...(isSelected && { 'aria-current': 'page' })}
      >
        {number}
      </Pill>
    </PaginationItem>
  );
};

export default PageNumber;
